import LoginUseCase from "@domains/salesFeatures/Login/useCases/LoginUseCase";
import LoginFeatureUseCase from "@domains/salesFeatures/Login/useCases/LoginFeature";
import ValidateOTPUseCase from "@domains/salesFeatures/Login/useCases/ValidateOTP";
import ForgotPasswordUseCase from "@domains/salesFeatures/Login/useCases/ForgotPasswordUseCase";
import ResetPasswordUseCase from "@domains/salesFeatures/Login/useCases/ResetPasswordUseCase";
import ChangePasswordUseCase from "@domains/salesFeatures/Login/useCases/ChangePasswordUseCase";
import UserUnblockCheckUseCase from "@domains/salesFeatures/Login/useCases/UserUnblockCheckUseCase";
import UserUnblockUseCase from "@domains/salesFeatures/Login/useCases/UserUnblockUseCase";
import ValidateForgotPasswordUseCase from "@domains/salesFeatures/Login/useCases/ValidateForgotPasswordUseCase";
import ValidateChangePasswordUseCase from "@domains/salesFeatures/Login/useCases/ValidateChangePasswordUseCase";
import LogoutUseCase from "@domains/salesFeatures/Login/useCases/LogoutUseCase";
import ResendOTPUsecase from "@domains/salesFeatures/Login/useCases/ResendOTPUsecase";
import FPDRedirectionURLUseCase from "@domains/salesFeatures/Login/useCases/FPDRedirectionURLUseCase";
import SingleSignOnUseCase from "@domains/salesFeatures/Login/useCases/SingleSignOnUseCase";
import ForgotLoginIDUseCase from "@domains/salesFeatures/Login/useCases/ForgotLoginIDUseCase";
import ValidateForgotLoginIdUseCase from "@domains/salesFeatures/Login/useCases/ValidateForgotLoginIDUseCase";
import GuidTokenUseCase from "@domains/salesFeatures/Login/useCases/GuidTokenUseCase";
import SSOUseCase from "@domains/salesFeatures/Login/useCases/SSOUseCase";
export default (function (repo) {
    return {
        login: {
            loginUseCase: new LoginUseCase(repo.login),
            newLoginUseCase: new LoginFeatureUseCase(repo.login),
            otpValidation: new ValidateOTPUseCase(repo.login),
            forgotPassword: new ForgotPasswordUseCase(repo.login),
            resetPassword: new ResetPasswordUseCase(repo.login),
            changePassword: new ChangePasswordUseCase(repo.login),
            userUnblockCheck: new UserUnblockCheckUseCase(repo.login),
            userUnblock: new UserUnblockUseCase(repo.login),
            validateForgotPassword: new ValidateForgotPasswordUseCase(repo.login),
            validateChangePassword: new ValidateChangePasswordUseCase(repo.login),
            logout: new LogoutUseCase(repo.login),
            resendOTP: new ResendOTPUsecase(repo.login),
            fpdURLRedirectionURL: new FPDRedirectionURLUseCase(repo.login),
            validateSingleSignOn: new SingleSignOnUseCase(repo.login),
            forgotLoginId: new ForgotLoginIDUseCase(repo.login),
            validateForgotLoginID: new ValidateForgotLoginIdUseCase(repo.login),
            getGuidToken: new GuidTokenUseCase(repo.login),
            getSSOLoginData: new SSOUseCase(repo.login),
        },
    };
});
